import { render } from "./SpeciesModal.vue?vue&type=template&id=64ad19d1&scoped=true"
import script from "./SpeciesModal.vue?vue&type=script&lang=js"
export * from "./SpeciesModal.vue?vue&type=script&lang=js"

import "./SpeciesModal.vue?vue&type=style&index=0&id=64ad19d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ad19d1"]])

export default __exports__